export { ChartPage as default } from 'src/components/pages/Ir/Financial/Chart'
